import React from "react";

import {
    Container,
    Paper,
    Table,
    TableContainer,
    TableRow,
    TableCell,
    TableHead,
    TableBody
} from "@mui/material";

export default function Voorschot(props) {

    const betrokkene = props.betrokkene;

    return (
        <div>
            <Container>
                <TableContainer component={Paper}>
                    <Paper>
                        <Table sx={{ borderStyle: "solid", borderWidth: 2 }}>
                            <TableHead>
                                <TableCell><img src="/Athenos.png" alt="logo" /></TableCell>
                                <TableCell>bevoorschottings-app</TableCell>
                            </TableHead>
                            <TableBody>
                                <TableRow sx={{ borderTopStyle: "solid" }}></TableRow>
                                <TableRow>
                                    <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0.5 }} colSpan={2}>Opmerkingen</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0.5 }}>berekening geschikt?</TableCell>
                                    <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0.5 }}>{betrokkene.geschikt}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0.5 }}>opmerkingen t.a.v. omzetverloop:</TableCell>
                                    <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0.5 }}>{betrokkene.opmerking}</TableCell>
                                </TableRow>
                                <TableRow sx={{ borderTopStyle: "solid" }}></TableRow>
                                <TableRow>
                                    <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0.5 }}>benaderde bedragen</TableCell>
                                    <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0.5 }}>circa</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0.5 }}>voorschot per maand vanaf incident</TableCell>
                                    <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0.5, fontWeight: "bold" }}>{new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(betrokkene.voorschotPerMaand)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0.5 }}>verlies aan verdien-vermogen in jaar incident</TableCell>
                                    <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0.5, fontWeight: "bold" }}>{new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(betrokkene.verliesInJaar)}</TableCell>
                                </TableRow>
                            </TableBody>

                        </Table>
                    </Paper>
                </TableContainer>
            </Container>
        </div>
    );
}